import { render, staticRenderFns } from "./versionInfo.vue?vue&type=template&id=296cac37&"
import script from "./versionInfo.vue?vue&type=script&lang=js&"
export * from "./versionInfo.vue?vue&type=script&lang=js&"
import style0 from "./versionInfo.vue?vue&type=style&index=0&id=296cac37&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports